import styled from "@emotion/styled";

import { BaseLink } from "~/components/common/base-link";

export const SocialLink = styled(BaseLink)`
  padding-block: 0;
  padding-inline: 10px;
`;

export const AuthorSocialLinkContainer = styled.div`
  ${SocialLink}:first-child {
    padding-inline-start: 0;
  }
  ${SocialLink}:last-child {
    padding-inline-end: 0;
  }
`;
